import type { ReactElement } from 'react';

import type { ConnectorProfile } from '@/shared/api/generated/catalog';

import { TILE_TEXT } from '../model/register';

/* A source family's tile: two letters on the family's own wash.
 *
 * **One component for the source's page and the register dialog**, because the tile is how a reader
 * recognises a family before reading its name — and two tiles that disagreed about a family's hue
 * would teach two different associations. The hue is CSS keyed on `data-type`, so a family the
 * stylesheet does not know falls back to the neutral wash rather than borrowing another's.
 *
 * Decorative: the family's name is always rendered beside it, so the tile is hidden from assistive
 * technology rather than announced as "Pg".
 */
export function ConnectorTile({
  type,
  size = 'large',
}: {
  readonly type: ConnectorProfile['connector_type'];
  readonly size?: 'large' | 'small';
}): ReactElement {
  return (
    <span
      className={size === 'small' ? 'lq-ctile lq-ctile--small' : 'lq-ctile'}
      data-type={type}
      aria-hidden="true"
    >
      {TILE_TEXT[type]}
    </span>
  );
}
